import BaseMonitor from './base';
let HostedMediaSessionMonitor = function() { this.init.apply(this, arguments); };
HostedMediaSessionMonitor.prototype = Kadenze.Util.extendClass(BaseMonitor, {

  getRenderer: function(){
    try {
      return this.media.hostedRenderer;
    } catch(e) {
      this.error(e);
      this.warn('You must implement a hostedRenderer attribute on: ' + this.media.contstructor.name);
      this.warn('Monitoring not enabled');
      return null;
    }
  }
});

export default HostedMediaSessionMonitor;
